export const PROPOSAL_REVIWEWERS_FETCH_REQUESTED = 'PROPOSAL_REVIWEWERS_FETCH_REQUESTED'
